import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { siteConfig } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="revolt-container">
        <div className="footer-content">
          {/* Logo */}
          <div className="footer-logo">
            Elina K.
          </div>

          {/* Links */}
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/gallery" className="footer-link">Portfolio</Link>
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>

          {/* Social & Contact */}
          <div className="social-links">
            <a 
              href={`mailto:${siteConfig.email}`}
              className="social-link"
              title={siteConfig.email}
            >
              <Mail className="w-5 h-5" />
            </a>
            <a 
              href={`https://instagram.com/${siteConfig.instagram.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title={siteConfig.instagram}
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a 
              href={`https://wa.me/${siteConfig.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title={`WhatsApp ${siteConfig.phone}`}
              data-testid="footer-whatsapp-link"
            >
              <WhatsAppIcon className="w-5 h-5" />
            </a>
          </div>
        </div>
        
        {/* Instagram Link */}
        <div className="text-center mt-lg py-8" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <a 
            href={`https://instagram.com/${siteConfig.instagram.replace('@', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-[#b8b8b8] hover:text-[#c9a87c] transition-colors"
          >
            <Instagram className="w-6 h-6" />
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '1rem', letterSpacing: '0.05em' }}>
              {siteConfig.instagram}
            </span>
          </a>
        </div>
        
        {/* Copyright */}
        <div className="text-center mt-lg" style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '2rem' }}>
          <p style={{ color: 'var(--text-subtle)', fontSize: '0.8rem' }}>
            © {new Date().getFullYear()} Elina K. Photography. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
